import { combineReducers } from "redux";
import ambassador_invoice from "../features/admin/ambassador_invoice/Slice";

const ambassadorInvoiceSection = combineReducers({
  ambassador_invoice: ambassador_invoice,
});

export default ambassadorInvoiceSection;
